import { render, staticRenderFns } from "./HtmlEditor.vue?vue&type=template&id=4b0c622d&scoped=true&"
import script from "./HtmlEditor.vue?vue&type=script&lang=js&"
export * from "./HtmlEditor.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditor.vue?vue&type=style&index=0&id=4b0c622d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0c622d",
  null
  
)

export default component.exports